// Icons
import {
  RteBoldIcon,
  RteItalicIcon,
  RteUnderlineIcon,
  RteStrikethroughIcon,
  RteUlIcon,
  RteOlIcon,
} from 'constants/icons';

function RTEMenuBar({ editor }) {
  if (!editor) {
    return null;
  }

  return (
    <div className="editor-toolbar">
      <button
        title="Bold"
        onClick={() => editor.chain().focus().toggleBold().run()}
        disabled={!editor.can().chain().focus().toggleBold().run()}
        className={`toolbar-btn ${editor.isActive('bold') ? 'is-active' : ''}`}
      >
        <RteBoldIcon />
      </button>
      <button
        title="Italic"
        onClick={() => editor.chain().focus().toggleItalic().run()}
        disabled={!editor.can().chain().focus().toggleItalic().run()}
        className={`toolbar-btn ${editor.isActive('italic') ? 'is-active' : ''}`}
      >
        <RteItalicIcon />
      </button>
      <button
        title="Underline"
        onClick={() => editor.chain().focus().toggleUnderline().run()}
        className={`toolbar-btn ${editor.isActive('underline') ? 'is-active' : ''}`}
      >
        <RteUnderlineIcon />
      </button>
      <button
        title="Strikethrough"
        onClick={() => editor.chain().focus().toggleStrike().run()}
        disabled={!editor.can().chain().focus().toggleStrike().run()}
        className={`toolbar-btn ${editor.isActive('strike') ? 'is-active' : ''}`}
      >
        <RteStrikethroughIcon />
      </button>
      <div className="toolbar-divider" />
      <button
        title="Bullet List"
        onClick={() => editor.chain().focus().toggleBulletList().run()}
        className={`toolbar-btn ${editor.isActive('bulletList') ? 'is-active' : ''}`}
      >
        <RteUlIcon />
      </button>
      <button
        title="Numbered List"
        onClick={() => editor.chain().focus().toggleOrderedList().run()}
        className={`toolbar-btn ${editor.isActive('orderedList') ? 'is-active' : ''}`}
      >
        <RteOlIcon />
      </button>
    </div>
  );
}

export default RTEMenuBar;
